<div class="sl-loader"
    [class.sl-loader_small]="small"
    [class.sl-loader_light]="light"></div>